import { initContract } from '@ts-rest/core';
import { publicPrizeContract } from './prize.public.contract';
import { authPrizeContract } from './prize.auth.contract';
import { adminPrizeContract } from './prize.admin.contract';

const c = initContract();

export const prizeContract = c.router(
  {
    public: publicPrizeContract,
    auth: authPrizeContract,
    admin: adminPrizeContract,
  },
  {
    pathPrefix: '/prizes',
    strictStatusCodes: true,
  }
);

export * from './prize.public.contract';
export * from './prize.auth.contract';
export * from './prize.admin.contract';
export * from './models';
